export default __webpack_public_path__ + "static/media/css3.4e67641b.png";